import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function GetSensitiveDataChangesService(token) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${URL_AUTH}/api/admin/v1/sensitive`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.data.data);
      resolve(response.data.data);
    } catch (error) {
      reject(error);
    }
  });
}